import script from "./TariffCardView.vue?vue&type=script&setup=true&lang=js"
export * from "./TariffCardView.vue?vue&type=script&setup=true&lang=js"

import "./TariffCardView.vue?vue&type=style&index=0&id=640ead46&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-640ead46"]])

export default __exports__